

  import { Component, Vue } from 'vue-property-decorator'
  import axios from 'axios';
  import { GF } from '../helpers/gf';

  import WrsAlert from './wrsControls/WrsAlert.vue';
  import WrsSecurityDialog from './wrsControls/WrsSecurityDialog.vue';
  import WrsWizardStepHeader from './wrsControls/WrsWizardStepHeader.vue';
  import WrsWizardStepButtons from './wrsControls/WrsWizardStepButtons.vue';
  import WrsSearchButtons from './wrsControls/WrsSearchButtons.vue';

  import WrsViText from './wrsControls/viControls/WrsViText.vue';
  import WrsViDate from './wrsControls/viControls/WrsViDate.vue';
  import WrsViCheckbox from './wrsControls/viControls/WrsViCheckbox.vue';
  import WrsLabel from './wrsControls/WrsLabel.vue';

  import { IS_PRODUCTION_ENVIRONMENT, IS_VUEJS_ENVIRONMENT } from '../../olsStateManagement/helpers/constants';
  import { userService } from '../../olsStateManagement/services/devAuth.service';
  import AuthService from '../../olsStateManagement/services/auth.service';
  import {DEFAULT_ROOT_URL} from '../../olsStateManagement/helpers/constants'

  const authService = new AuthService();

  @Component({
    components: {
      'wrs-alert': WrsAlert,
      'wrs-security-dialog': WrsSecurityDialog,
      'wrs-wizard-step-header': WrsWizardStepHeader,
      'wrs-wizard-step-buttons': WrsWizardStepButtons,
      'wrs-search-buttons': WrsSearchButtons,
      'wrs-vi-text': WrsViText,
      'wrs-vi-checkbox': WrsViCheckbox,
      'wrs-vi-date': WrsViDate,
      'wrs-label': WrsLabel,
    },
  })

  export default class App extends Vue {
    public VM: any = {};

    public STEPIDS: any = {
      stepClient: 1,
      stepValidation: 2,
    };

    public currentOlsUser: any = {};
    public clientData: any = {};

    public isAuthorized: boolean = false;
    public emailVerified: boolean = false;
    public userName: string = ""

    public loader: any = {
      loaded: false,
      loadedNoError: false,
      loading: false,
    };

    public dialog: any = {
      open: false,
      title: "",
      question: "",
      action: "",
      cartId: 0,
      transactionId: 0
    }

    public name: string = "";

    public isMobile: boolean = false;

    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    }

    //created() {
    //  if (!IS_PRODUCTION_ENVIRONMENT && IS_VUEJS_ENVIRONMENT) {
    //    import('../../olsStateManagement/css/olsOverrideDev.scss')
    //  }
    //}

    mounted() {
      if (!IS_PRODUCTION_ENVIRONMENT && IS_VUEJS_ENVIRONMENT) {
        let userData = userService.getUser();
        userData
          .then((result) => {
            this.clientData = JSON.parse(JSON.stringify(result));
            this.loadData();
            this.isAuthorized = this.clientData.isLoggedIn;
          });
      } else {

        authService.getUser()
          .then((user:any) => {
            if(user) {
              this.emailVerified = authService.emailVerified();

              if(user.profile.email_verified) {
                this.isAuthorized = authService.isAuthorized();

                if(this.isAuthorized) {

                  this.userName = user.profile.name != null ? user.profile.name : user.profile.email;

                  let pOlsUser = sessionStorage.getItem('olsUser')
                  if(pOlsUser){
                    let olsUser = JSON.parse(pOlsUser);

                    axios
                      .get("olsUserProfile/getUserDefaultClient/" + olsUser.olsUserId + '/0/true',)
                        .then(response => {
                          this.clientData = response.data;
                          this.loadData()
                      })
                      .catch(error => console.log(error))
                  }
                }
                else {
                  authService.logout();
                }
              }
            }
          })
          .catch(error => console.log(error))
          .finally(() => {
            this.loader.loading = false;
            this.loader.loaded = true;
          })
      }
    }

    loadData() {
      this.loader.loading = true;

      axios
        .get('client/getabstractviewmodel/' + this.clientData.olsUserId + '/' + this.clientData.clientId)
        .then(response => {
          this.VM = response.data;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
          this.loader.loaded = true;
          this.loader.loadedNoError = !this.VM.securityError.hasError;
        });
    }

    //#region Step Client
    //getters
    get canFindDriver() {
      if (!this.loader.loaded || this.loader.loading) return false;

      if (this.VM.multiple) {
        return !this.VM.surname.hasError && !this.VM.dateOfBirth.hasError && !this.VM.dlNumber.hasError;
      }
      else {
        return !this.VM.surname.hasError && !this.VM.dateOfBirth.hasError && !this.VM.dlNumber.hasError && this.VM.abstracts.length == 0;
      }
    }

    get canAddToCartBulk() {
      return this.canAddToCart();
    }

    canAddToCart() {
      if (this.VM.runtimeError.hasError) return false;

      var count = this.VM.abstracts.length;
      var isReachedMax = false;
      if (count > this.VM.countOfCartItemsCanBeAdded) {
        console.log(count);
        isReachedMax = true;
        GF.setAlertWarning(this.VM.runtimeError, this.VM.maximumOfCartItemsReachedError);
      }
      else {
        GF.clearAlert(this.VM.runtimeError);
      }

      var anySelected = count > 0;

      return !this.VM.disclamer.error && !this.VM.abstractError.hasError && anySelected && !isReachedMax;
    }
    searchParamsChanged() {
      GF.clearAlert(this.VM.abstractError);
    }

    getStepDataRequest(isForSearch: Boolean) {
      let dr = {
        clientId: this.clientData.clientId,
        olsUserId: this.clientData.olsUserId,
        surname: "",
        dateOfBirth: "",
        dlNumber: "",
        multiple: this.VM.multiple,
        ids: [] as any,
      };

      if (isForSearch) {
        dr.surname = this.VM.surname.value;
        dr.dateOfBirth = this.VM.dateOfBirth.value;
        dr.dlNumber = this.VM.dlNumber.value;
      }
      else {
        for (var i = 0; i < this.VM.abstracts.length; i++) {
          dr.ids.push(this.VM.abstracts[i].clientId)
        }
      }

      return dr;
    }
    findDriver() {
      this.loader.loading = true;

      let dr = this.getStepDataRequest(true);

      axios
        .post('client/findclientforabstract', dr)
        .then(response => {
          this.VM.abstractError = response.data.abstractError;
          if (!this.VM.abstractError.hasAny) {
            let rec = this.VM.abstracts.find((element: any) => element.clientId == response.data.abstracts[0].clientId);
            if (!rec) {
              this.VM.abstracts.push(response.data.abstracts[0]);
              this.clearFindDriver();
            }
            else {
              GF.clearAlert(this.VM.abstractError);
              GF.setAlertWarning(this.VM.abstractError, this.VM.wizardLabels.DriverAddedToAbstractRequest);
            }
          }
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
        });
    }
    clearFindDriver() {
      this.VM.surname.value = "";
      this.VM.dateOfBirth.value = null;
      this.VM.dlNumber.value = "";
      GF.clearAlert(this.VM.abstractError);

      //Used when testing
      // if (this.VM.multiple) {
      //  if (this.VM.abstracts.length == 0) {
      //    this.VM.surname.value = "MAHAR";
      //    this.VM.dateOfBirth.value = "1966-01-05";
      //    this.VM.dlNumber.value = "42503";
      //  }
      //  else if (this.VM.abstracts.length == 1) {
      //    this.VM.surname.value = "SKOGMAN DORAN";
      //    this.VM.dateOfBirth.value = "1947-05-22";
      //    this.VM.dlNumber.value = "133118";
      //  }
      //  else {
      //    this.VM.surname.value = "BROOKS";
      //    this.VM.dateOfBirth.value = "1958-11-25";
      //    this.VM.dlNumber.value = "141962";
      //  }
      // }
      // else {
      //   this.VM.surname.value = "SKOGMAN DORAN";
      //    this.VM.dateOfBirth.value = "1947-05-22";
      //    this.VM.dlNumber.value = "107024";

      //  this.VM.surname.value = "ANTTILA";
      //  this.VM.dateOfBirth.value = "1964-07-29";
      //  this.VM.dlNumber.value = "141552";
      // }
    }

    getTableHeaders(isMultiple: any) {
      if (isMultiple) {
        return [
          { text: '', value: 'clientId', width: '50px' },
          { text: this.VM.wizardLabels.ClientName, value: 'fullName', align: 'start', sortable: false, width: '' }, //200px
          { text: this.VM.wizardLabels.DateOfBirth, value: 'dateOfBirth', sortable: false, width: '' }, //120px
          { text: this.VM.wizardLabels.DriverLicenceNo, value: 'documentNumber', sortable: false, width: '' }, //120px
        ];
      }
      else {
        return [
          { text: '', value: 'clientId', width: '0px' },
          { text: this.VM.wizardLabels.ClientName, value: 'fullName', align: 'start', sortable: false, width: '' },
          { text: this.VM.wizardLabels.DateOfBirth, value: 'dateOfBirth', sortable: false, width: '' },
          { text: this.VM.wizardLabels.DriverLicenceNo, value: 'documentNumber', sortable: false, width: '' },
        ];
      }
    }
    removeItem(clientId: any) {
      if (clientId == 0) return;
      this.VM.abstracts = this.VM.abstracts.filter((element: any) => element.clientId != clientId);
    }

    get hideDefaultFooter() {
      if (this.VM.abstracts) {
        return this.VM.abstracts.length < 10;
      }
      return false;
    }

    ////methods
    addToCart() {
      if (this.canAddToCart()) {
        let dr = this.getStepDataRequest(false);

        axios
          .post('client/addabstracttocart', dr)
          .then(response => {
            this.VM.abstractError = response.data.abstractError;
            if (!this.VM.abstractError.hasAny) {
              //this.VM.currentStepId = -99;
            } else if (this.VM.abstractError.hasSuccess) {
              this.VM.currentStepId = this.STEPIDS.stepValidation;
            }
            this.VM.jumpToCart = response.data.jumpToCart;
          })
          .catch(error => console.log(error))
          .finally(() => {
            if (this.VM.jumpToCart) {
              this.redirectToFullURL(this.VM.shoppingCartWebAddress);
            }
          });
      }
    }

    redirectToUrl(url: string) {
      return window.location.href = DEFAULT_ROOT_URL + url;
    }

    redirectToFullURL(url:string) {
      return window.location.href = url;
    }

  }

